if (!customElements.get("component-accordions")) {
  class Accordions extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.accordions(
        ".accordion__item",
        ".accordion__content",
        ".accordion__control",
        "open"
      );
    }

    accordions(
      accordionsSelector,
      contentSelector,
      controlSelector,
      activeClass
    ) {
      const accordions = this.querySelectorAll(accordionsSelector);

      function openAccordion(item, content, controller) {
        item.classList.add(activeClass);
        content.style.maxHeight = content.scrollHeight + "px";
        controller.setAttribute("aria-expanded", true);
        content.setAttribute("aria-hidden", false);
      }

      function hideAccordion(item, content, controller) {
        item.classList.remove(activeClass);
        content.style.maxHeight = "";
        controller.setAttribute("aria-expanded", false);
        content.setAttribute("aria-hidden", true);
      }

      accordions.forEach((el) => {
        const content = el.querySelector(contentSelector);
        const controller = el.querySelector(controlSelector);

        if (el.classList.contains(activeClass)) {
          openAccordion(el, content, controller);
        }

        el.addEventListener("click", ({ currentTarget, target }) => {
          const currentContent = currentTarget.querySelector(contentSelector),
            currentController = currentTarget.querySelector(controlSelector);

          if (target.closest(controlSelector)) {
            if (el.classList.contains(activeClass)) {
              hideAccordion(currentTarget, currentContent, currentController);
            } else {
              accordions.forEach((item) => {
                const content = item.querySelector(contentSelector),
                  controller = item.querySelector(controlSelector);
                hideAccordion(item, content, controller);
              });

              openAccordion(currentTarget, currentContent, currentController);
            }
          }
        });
      });
    }
  }

  customElements.define("component-accordions", Accordions);
}
